import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="bg-[#0B0B1A] py-12 md:py-20 px-4 overflow-hidden relative" data-id="element-74">
      {/* Background glows */}
      <div className="absolute top-0 left-1/4 w-[600px] h-[400px] bg-[#FF00FF] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-75" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[300px] bg-[#00D4FF] opacity-10 blur-[120px] rounded-full pointer-events-none" data-id="element-76" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-3 bg-[#FF3333] text-white px-6 py-2 md:px-8 md:py-3 rounded-full font-black text-xl md:text-3xl mb-8 animate-pulse shadow-[0_0_30px_rgba(255,51,51,0.6)] border-2 border-white/20" data-id="element-78">
          <span className="text-2xl md:text-4xl" data-id="element-79">⏳</span> PRECIO LANZAMIENTO
        </motion.div>

        <p className="text-lg md:text-xl text-gray-300 font-medium mb-4" data-id="element-80">
          💻 Para cualquier persona que usa internet y quiere proteger sus
          cuentas.
        </p>

        <h2 className="text-xl md:text-2xl text-[#00D4FF] font-bold mb-2 uppercase tracking-wider" data-id="element-81">
          🔐 Colección
        </h2>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-8 tracking-tight" data-id="element-82">
          Ciberseguridad para
          <br className="hidden md:block" data-id="element-83" /> Personas Comunes
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-8 cursor-pointer" onClick={scrollToPricing} data-id="element-84">
          <img src="https://cdn.magicpatterns.com/uploads/ibm6jBTNSEkwpcfh2tSvYZ/MOCKUP_(2).png" alt="Colección Ciberseguridad para Personas Comunes" className="w-full h-auto drop-shadow-2xl" data-id="element-85" />
        </motion.div>

        <div className="max-w-3xl mx-auto mb-10" data-id="element-86">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="relative bg-white/5 rounded-2xl p-8 md:p-10 mb-6 border border-[#FF00FF]/30 shadow-[0_0_60px_rgba(255,0,255,0.15),0_0_120px_rgba(0,212,255,0.08)]" data-id="element-87">
            <div className="absolute top-0 left-0 w-20 h-20 bg-[#FF00FF] opacity-20 blur-[40px] rounded-full pointer-events-none" data-id="element-88" />
            <div className="absolute bottom-0 right-0 w-20 h-20 bg-[#00D4FF] opacity-20 blur-[40px] rounded-full pointer-events-none" data-id="element-89" />

            <p className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-[#FF00FF] text-center leading-tight tracking-tight" data-id="element-90">
              Aprende a proteger tus cuentas, evitar estafas y recuperar accesos
              hackeados sin ser experto en tecnología.
            </p>
          </motion.div>
          <p className="text-lg md:text-xl text-gray-400 font-bold italic" data-id="element-91">
            Simple. Claro. Paso a paso.
          </p>
        </div>

        <CtaButton text="👉 QUIERO PROTEGER MIS CUENTAS" className="w-full md:w-auto md:px-12 md:py-6 md:text-3xl" data-id="element-92" />
      </div>
    </section>;
}